import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private langJsonUrl = 'assets/data/configuration.json';

  constructor(private http: HttpClient) {}

  sharedLoginReqData: any;

  getLangJsonData(): Observable<any> {
    return this.http.get<any>(this.langJsonUrl);
  }
}
